<template>
  <modal @close="$emit('close')">
    <div slot="header">
      <h4>{{ lead.ref_id }} - Voice message</h4>
    </div>
    <div slot="body">
      <div class="row">
        <div class="col">
          <div class="select-wrap h-auto">
            <label>Note</label>
            <textarea v-model="followUp.notes" class="select-wrap-textarea form-control" name="notes" cols="30"
                      rows="10" placeholder="Enter your voice message notes"
            />
          </div>
          <error-field :errors="errors" field="notes" />
        </div>
      </div>
    </div>
    <div slot="footer">
      <div class="row">
        <div class="col text-right">
          <button type="button" class="btn btn-secondary" @click="$emit('close')">
            Cancel
          </button>
          <button class="btn btn-primary ld-ext-right"
                  :class="loadingButton ? 'running' : ''"
                  :disabled="buttonDisabled"
                  @click="sendFollowUpVoice(lead.id)"
          >
            Send
            <div class="ld ld-ball ld-flip" />
          </button>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import axios from 'axios';
import { mapActions } from 'vuex';
import toastr from 'toastr';
import Errors from '../../../classes/Errors';
import ErrorField from '../../ErrorField';
import Modal from '../../Modal';

export default {
  components: {
    Modal,
    ErrorField,
  },
  props: {
    lead: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    buttonDisabled: false,
    loadingButton: false,
    errors: new Errors(),
    followUp: {
      notes: '',
    },
  }),
  methods: {
    ...mapActions(['addFollowUp']),
    sendFollowUpVoice(id) {
      this.buttonDisabled = true;
      this.loadingButton = true;
      axios
        .post(`/leads/${id}/follow-ups`, {
          type_id: 3,
          notes: this.followUp.notes,
        })
        .then(res => {
          toastr.success('Successfully added follow up');
          this.addFollowUp(res.data.data);
          this.$emit('close');
          this.errors.clear();
        })
        .catch(err => {
          this.errors.record(err.response.data.error);
        })
        .finally(() => {
          this.loadingButton = false;
          this.buttonDisabled = false;
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/leads/followUps/Voice.vue